var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V3.99998H22L18 0Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8V4H18L22 8Z",
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 22,
    height: 12,
    rx: 1,
    fill: "#10B981"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31997 14.224L10.048 17H9.02397L7.76797 14.984L6.59197 17H5.57597L7.30397 14.224L5.56797 11.44H6.59197L7.85597 13.472L9.03997 11.44H10.056L8.31997 14.224ZM11.9612 16.264H13.8412V17H11.0492V11.44H11.9612V16.264ZM16.4359 17.056C16.0626 17.056 15.7266 16.992 15.4279 16.864C15.1292 16.7307 14.8946 16.544 14.7239 16.304C14.5532 16.064 14.4679 15.784 14.4679 15.464H15.4439C15.4652 15.704 15.5586 15.9013 15.7239 16.056C15.8946 16.2107 16.1319 16.288 16.4359 16.288C16.7506 16.288 16.9959 16.2133 17.1719 16.064C17.3479 15.9093 17.4359 15.712 17.4359 15.472C17.4359 15.2853 17.3799 15.1333 17.2679 15.016C17.1612 14.8987 17.0252 14.808 16.8599 14.744C16.6999 14.68 16.4759 14.6107 16.1879 14.536C15.8252 14.44 15.5292 14.344 15.2999 14.248C15.0759 14.1467 14.8839 13.992 14.7239 13.784C14.5639 13.576 14.4839 13.2987 14.4839 12.952C14.4839 12.632 14.5639 12.352 14.7239 12.112C14.8839 11.872 15.1079 11.688 15.3959 11.56C15.6839 11.432 16.0172 11.368 16.3959 11.368C16.9346 11.368 17.3746 11.504 17.7159 11.776C18.0626 12.0427 18.2546 12.4107 18.2919 12.88H17.2839C17.2679 12.6773 17.1719 12.504 16.9959 12.36C16.8199 12.216 16.5879 12.144 16.2999 12.144C16.0386 12.144 15.8252 12.2107 15.6599 12.344C15.4946 12.4773 15.4119 12.6693 15.4119 12.92C15.4119 13.0907 15.4626 13.232 15.5639 13.344C15.6706 13.4507 15.8039 13.536 15.9639 13.6C16.1239 13.664 16.3426 13.7333 16.6199 13.808C16.9879 13.9093 17.2866 14.0107 17.5159 14.112C17.7506 14.2133 17.9479 14.3707 18.1079 14.584C18.2732 14.792 18.3559 15.072 18.3559 15.424C18.3559 15.7067 18.2786 15.9733 18.1239 16.224C17.9746 16.4747 17.7532 16.6773 17.4599 16.832C17.1719 16.9813 16.8306 17.056 16.4359 17.056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXsl);
export default __webpack_public_path__ + "static/media/xsl.b6faabfea33d9725aef29a8e14b2d705.svg";
export { ForwardRef as ReactComponent };